import React from 'react';
import SelfPacedContainer from 'components/assessments/self-paced-container';
import { Stack } from 'react-bootstrap';
import SelfPacedHeader from 'components/assessments/self-paced-header';

function SelfPaced({ type, time }) {
  return (
    <Stack gap={0}>
      <SelfPacedHeader type={type} />
      <SelfPacedContainer type={type} time={time} />
    </Stack>
  );
}

export default SelfPaced;
